import { defineNuxtPlugin, useHead, useMobileApp } from '#imports'

export default defineNuxtPlugin({
    name: 'mobile-app-viewport',
    setup() {
        if (!useMobileApp().isMobileApp) return

        useHead({
            meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }],
        })
    },
})
